import {Alert, Badge, Col, Container, Row} from "react-bootstrap";
import "./css/MsisdnPage.css"
import React, {useEffect, useRef, useState} from "react";
import {getMsisdnsForCompanyId} from "../API/msisdnApi";
import sortMsisdn from '../utils/msisdnSorter.js'
import IconButton from "../components/IconButton";
import {faCircleInfo, faPlus} from "@fortawesome/free-solid-svg-icons";
import {
    addMsisdnExtra,
    deleteMsisdnExtra,
    fetchDataFromAllPages,
    getMsisdnExtras,
    updateMsisdnExtras
} from "../API/companyApi.js";

import useCompanyId from "../Hooks/useCompanyId.js";
import RegisterMsisdnModal from "../components/Modals/RegisterMsisdnModal.jsx";
import ClaimGuard from "../components/Auth/ClaimGuard";
import {REG_MSISDN} from "../Claims";
import ManageExtrasModal from "../components/Modals/ActionModals/ManageExtrasModal";
import LoadingSpinner from "../components/Loading/LoadingSpinner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PaginationComponent from "../components/core/Pagination/PaginationComponent";
import {useTranslation} from "react-i18next";
import Search from "../components/core/Components/Search";
import ConditionalRender, {Fallback} from "../components/ConditionalRender";
import MsisdnRow from "../components/MsisdnRow";
import MyTable from "../components/core/Components/MyTable";
import useCompany from "../Hooks/useCompany";


export default function MsisdnPage()
{
    const [msisdns, setMsisdns] = useState(null);
    const [creatingMsisdn, setCreatingMsisdn] = useState(false);
    const [showManageExtras, setShowManageExtras] = useState(false);
    const companyId = useCompanyId()
    const company = useCompany()

    const [msisdnKeysMaps, setMsisdnKeysMaps] = useState([])

    const [page, setPage] = useState(0)
    const [search, setSearch] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const [geofences, setGeofences] = useState([])

    const [viewLocationsForMsisdn, setViewLocationsForMsisdn] = useState(null)


    const {t} = useTranslation()

    useEffect(()=> {
        getMsisdns();
    }, [creatingMsisdn, page])

    useEffect(()=> {
        getMsisdns(false);
    }, [search])

    useEffect(() => {
        fetchMsisdnExtras();
    }, [])

    // This walks every page of the company's geofence list (~100 requests for a company with
    // ~1000 work locations). It's only needed by the per-row "view locations" / "manage planning"
    // modals, and only for whichever row the admin actually opens one of those for - so instead of
    // fetching it unconditionally on every page load, load it once, on demand, the first time a
    // row asks for it (see ensureGeofencesLoaded, passed down as onNeedGeofences).
    const geofencesLoadingRef = useRef(false)
    const geofencesLoadedRef = useRef(false)

    async function ensureGeofencesLoaded() {
        if(geofencesLoadedRef.current || geofencesLoadingRef.current || !companyId)
            return

        geofencesLoadingRef.current = true
        setGeofences([]);

        try {
            for await (const geofencesPage of fetchDataFromAllPages(`v1/geofence/company/${companyId}`, 0, { includeEnlargement: true })) {
                geofencesPage.forEach(geofence => {
                    setGeofences(geofences => [...geofences, geofence]);
                });
            }
            geofencesLoadedRef.current = true
        }
        finally {
            geofencesLoadingRef.current = false
        }
    }

    async function fetchMsisdnExtras()
    {
        try {
            const response = await getMsisdnExtras(companyId)
            setMsisdnKeysMaps(response.data)
        }
        catch(ex)
        {
            console.error(ex);
        }
    }

    async function getMsisdns(showLoading = true)
    {
        try {
            if(showLoading)
                setIsLoading(true)

            const response = await getMsisdnsForCompanyId(companyId, page, search)
            const msisdnsPaged = response.data
            //TODO Sort MSISDNs in the backend
            msisdnsPaged.data = sortMsisdn(msisdnsPaged.data)
            setMsisdns(msisdnsPaged)
        }
        catch(ex)
        {
            console.error(ex);
        }
        finally {
            if(showLoading)
                setIsLoading(false)
        }
    }

    async function onKeysUpdated()
    {
        await fetchMsisdnExtras()
        await getMsisdns()
    }

    function handleViewLocationsForMsisdn(msisdn)
    {
        setViewLocationsForMsisdn(msisdn)
    }

    if(!msisdns)
        return <LoadingSpinner className='mt-4'/>;

    // const overviewColumnSize = Math.min(10 + msisdnKeysMaps.length, 12);

    return (
        <div className="msisdn-page">
            <Container fluid>
                <Row className="justify-content-center">
                    <Col>
                        <Row className={'mb-2'}>
                            <Col lg={4} className='d-flex align-items-start flex-column'>
                                <div className='d-flex align-items-center'>
                                    <h1 className={'mb-0'}>{t('pages.workers.title')}</h1>
                                    <ConditionalRender condition={!company?.trialPeriod}>
                                        <Badge pill className={'ms-2 mt-2'}>{msisdns?.totalElements ?? 0}</Badge>
                                        <Fallback>
                                            <Badge pill className={'ms-2 mt-2'}>{msisdns?.totalElements ?? 0} / {company?.trialPeriod?.maxMsisdns}</Badge>
                                        </Fallback>
                                    </ConditionalRender>

                                </div>
                                <Search onSearch={(text) => setSearch(text)}/>
                            </Col>
                            <Col className="d-flex align-items-end justify-content-end">
                                {/*<ClaimGuard requiredClaim={UPDATE_COMPANY_ALL}>*/}
                                {/*    <IconButton icon={faKey} className='me-2'  bg={'white'} border='1px solid' borderColor='gray' onClick={() => setShowManageExtras(true)}/>*/}
                                {/*</ClaimGuard>*/}
                                <ClaimGuard requiredClaim={REG_MSISDN}>
                                    <IconButton icon={faPlus} color="white" bg="#198754"
                                                onClick={() => {setCreatingMsisdn(true);}}
                                                disabled={company?.trialPeriod?.suspended || company?.trialPeriod?.maxMsisdns <= msisdns?.totalElements}
                                    />
                                </ClaimGuard>
                                <RegisterMsisdnModal companyId={companyId} extras={msisdnKeysMaps} show={creatingMsisdn === true} onDismiss={() => setCreatingMsisdn(false)} onRegistered={getMsisdns}/>
                            </Col>
                        </Row>
                        <ConditionalRender condition={msisdns.data.length > 0}>
                            <MyTable alignMiddle hover={false}>
                                <thead>
                                <tr>
                                    <th>{t('pages.dashboard.workerName')}</th>
                                    <th>{t('pages.dashboard.workerId')}</th>             
                                    <th>{t('pages.dashboard.consumption')}</th>
                                    <th>{t('dialogs.note')}</th>
                                    <th>{t('pages.workers.statusText')}</th>
                                    {/*{msisdnKeysMaps.map((key) => <th key={key.key}>{key.key}</th>)}*/}
                                    <th width={80}>{t('global.operations.manage')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {
                                        msisdns.data.map(msisdn => <MsisdnRow key={msisdn.id} msisdn={msisdn} geofences={geofences} onNeedGeofences={ensureGeofencesLoaded} onMsisdnDeleted={getMsisdns} onUpdated={getMsisdns}/>)
                                    }
                                </tbody>
                            </MyTable>

                            <Fallback>
                                <div className='d-flex justify-content-center mt-5'>
                                    <Alert variant='warning' className='w-100'>
                                        <FontAwesomeIcon icon={faCircleInfo}/>
                                        <span className='ms-2'>{t('pages.workers.noWorkersFound')}</span>
                                    </Alert>
                                </div>
                            </Fallback>
                        </ConditionalRender>
                    </Col>
                </Row>
                <Row className={'mt-3'}>
                    <Col className={'d-flex justify-content-center'}>
                        <PaginationComponent lastPage={msisdns.lastPage} onPageChanged={(page) => setPage(page)}/>
                    </Col>
                </Row>
            </Container>


            <ManageExtrasModal
                active={showManageExtras}
                keys={msisdnKeysMaps}
                updateExtraKeys={updateMsisdnExtras}
                addExtraKey={addMsisdnExtra}
                deleteExtraKey={deleteMsisdnExtra}
                onCancel={() => {
                    setShowManageExtras(false)
                }}
                onUpdate={onKeysUpdated}
                onCreate={onKeysUpdated}
                onDelete={onKeysUpdated}
            />
        </div>
    )
}